import React, { Fragment } from 'react';
import { dateObj, dateStr, loadUserMessage, deleteUserMessage, downloadOrdersCsv } from './globals';
import { Languages } from './languages';

import DatePicker, { registerLocale } from 'react-datepicker';
import { Autocomplete as GoogleAutocomplete } from 'react-google-autocomplete';
import SearchLocationInput from './searchLocationInput';
import it from "date-fns/locale/it";
import Autocomplete from 'react-autocomplete';
// import { PageTitle, ScrollableGrid, ScrollableGridItem, UIPopup, UIInput, UIButton, UIButtonPad, UICheckbox, UIMessageBox } from '../components/guiElements';
import { SelectField, UIButton, UIMessageBox } from '../components/guiElements';
registerLocale("it", it);


//#region Basic Utilities

//#region Buttons

/* props: name, (button.class)type, (button.onClick)onClick, (button.children}.text, extraClass
 * class: ubutton + (props.extraClass)
*/
export class UButton extends React.Component {
    constructor(props) {
        super(props);
        this.btnClick = this.btnClick.bind(this);
    }

    btnClick(ev) {
        this.props.onClick(ev, this.props.type, this.props.name);
    }

    render() {
        let disabled = this.props.hasOwnProperty("disabled") && this.props.disabled ? "disabled" : ""; 
        
        return (
            <div className={"ubutton " + (this.props.extraClass || "")}><button disabled={disabled} className={this.props.type} onClick={this.btnClick}>{this.props.text}</button></div>
        );
    }
}


/* onClick, name, type, source, value, text
*/
export class ListButton extends React.Component {
    constructor(props) {
        super(props);
        this.buttonClick = this.buttonClick.bind(this);
    }

    buttonClick(ev) {
        //console.debug(`buttonClick ${this.props.source} ${this.props.type}`);
        this.props.onClick(ev, this.props.name, this.props.type, this.props.source, this.props.value);
    }

    render() {
        //console.debug("ListButton props: " + JSON.stringify(this.props));
        return (
            <button disabled={this.props.disabled ? this.props.disabled:false} className={this.props.type} onClick={this.buttonClick}>{this.props.text}</button>
        );
    }
}

//#endregion Buttons


//#region row Elements

export function UButtonGroup(props) {
    return (
        <div className={"row ubutton-group " + (props.rowClass || "")}><div className={"col " + (props.colClass || "")}>{props.children}</div></div>
    );
}


export function UButtonRow(props) {
    return (
        <div className={"row ubutton-row " + (props.rowClass || "")}>{props.children}</div>
    );
}


export function USearch(props) {
    return (
        <div className="input-group search">
            <div className={"input-element " + (props.rowClass || "")}>
                <div className="input-field ">
                    <input type="text" className={props.inputClass} value={props.value} placeholder={props.search} onChange={props.onChange} />
                </div>
                </div>
        </div>
    );
}


/* colClass, textClass, value
*/
export function ULabel(props) {
    return (<div className="row ulabel"><div className={"col " + (props.colClass || "")}><h6 className={props.textClass}>{props.value}</h6></div></div>);
}


/* name, rowClass, colClass, textClass, text, element, onClick, action {text, class}
*/
export class UTitle extends React.Component {
    constructor(props) {
        super(props);
        this.meClick = this.meClick.bind(this);
    }

    meClick(ev) {
        if (typeof this.props.onClick === "function") this.props.onClick(ev, this.props.name);
    }

    render() {
        const element = (!this.props.element ? (<div className="void" />) : (this.props.element === "element") ? (<div className="element" />) :
            (<div className="image-element" onClick={this.meClick} style={{ backgroundImage: "url(" + this.props.element + ")" }} />));
        const flatText = (!this.props.text ? (<div className="void" />) : (<h5 className={this.props.textClass}>{this.props.text}</h5>));
        const actionText = (!this.props.action ? (<div className="void" />) : (<h5 className={this.props.action.class} onClick={this.meClick}>{this.props.action.text}</h5>));

        return (
            <div className={"row utitle " + (this.props.rowClass || "")}><div className={"col " + (this.props.colClass || "")}>
                {element}{flatText}{actionText}
            </div></div>
        );
    }
}


/* name, rowClass, colClass, textClass {caption, value}, text {caption, value}, element
*/
export class UDescriptive extends React.Component {
    // constructor(props) {
    //     super(props);
    // }

    render() {
        const element = (!this.props.element ? (<div />) : (this.props.element === "element") ? (<div className="element" />) :
            (<div className="image-element" style={{ backgroundImage: "url(" + this.props.element + ")" }} />));
        return (
            <div className={"row udescriptive " + (this.props.rowClass || "")}><div className={"col " + (this.props.colClass || "")}>
                {element}
                <h5 className={"caption " + this.props.textClass.caption}>{this.props.text.caption + ":"}</h5>
                <h5 className={"value " + this.props.textClass.value}>{this.props.text.value}</h5>
            </div></div>
        );
    }
}


/* colClass, textClass, value
*/
export function UParagraph(props) {
    return (<div className="row uparagraph"><div className={"col " + (props.colClass || "")}><p className={props.textClass}>{props.value}</p></div></div>);
}


/* name, selection, disabled, rowClass, className, options [ {value, text} ], onChange
*/
export class USelect extends React.Component {
    constructor(props) {
        super(props);
        this.selChange = this.selChange.bind(this);
    }

    selChange(ev) {
        this.props.onChange(ev, this.props.name, ev.currentTarget.value);
    }

    render() {
        const options = this.props.options.map((el, idx) => (
            <option key={"opt-" + idx} value={el.value}>{el.text}</option>
        ));
        const select = (!this.props.disabled ? 
            (<select className={this.props.className}
                onChange={this.selChange}
                value={this.props.selection}>{options}
            </select>) :
            (<select
                className={this.props.className}
                value={this.props.selection}
                disabled>{options}</select>));
        return (
            <div className={"row uselect " + (this.props.rowClass || "")}>
                    <div className="col">{select}</div>
                </div>
        );
    }
}


/* name, rowClass, inputClass, value, pholder, onChange
*/
export class UInput extends React.Component {
    constructor(props) {
        super(props);
        this.inputChange = this.inputChange.bind(this);
        this.inputFocus = this.inputFocus.bind(this);
        this.input = React.createRef();
    }

    inputChange(ev) {
        let val = (ev.target.type == 'checkbox' || ev.target.type == 'radio') ? ev.target.checked : ev.target.value;
        this.props.onChange(ev, this.props.name, val);
    }

    inputFocus(ev) {
        if (!!this.input.current.focus) this.input.current.focus();
    }

    render() {
        return (
            <div className={"row uinput " + (this.props.rowClass || "")} onClick={this.inputFocus}>
                <div className="col">
                    <input ref={this.input} className={this.props.inputClass} type="text"
                        value={this.props.value} placeholder={this.props.pholder} onChange={this.inputChange} />
                </div>
            </div>
        );
    }
}


/* name, rowClass, colClass, value, text, onChange
*/
export class UCheckbox extends React.Component {
    constructor(props) {
        super(props);
        this.inputClick = this.inputClick.bind(this);
    }

    inputClick(ev) {
        const chk = ev.currentTarget.childNodes[0];
        chk.checked = !chk.checked;
        this.props.onChange(ev, this.props.name, chk.checked);
    }


    render() {  // IMPORTANT: do not change className of div[className="ucheckbox"]
        let error = this.props.hasOwnProperty("error") && this.props.error ? " error " : "";
        return (
            <div className={"row ucheckbox " + (this.props.rowClass || "")}>
                <div className={"col " + (this.props.colClass + "")}>
                    <div className="ucheckbox" onClick={this.inputClick}>
                        <input disabled={this.props.disabled} type="checkbox" value={this.props.name} checked={this.props.value} readOnly />
                        <span className="checkmark"></span>
                        <h6 className={error}>{this.props.text}</h6>
                        
                    </div>
                </div>
                
            </div>
        );
    }
}


/* name, group, rowClass, colClass, textClass[], text[], value, onChange, disabled
*/
export class URadioComplex extends React.Component {
    constructor(props) {
        super(props);
        this.radioClick = this.radioClick.bind(this);
    }

    radioClick(ev) {
        if (this.props.disabled) return;
        const radio = ev.currentTarget.childNodes[0];
        if (!radio.checked) this.props.onChange(ev, this.props.name, this.props.group);
    }

    render() {
        const textClass = this.props.textClass || [];
        return (
            <div className={"row uradio uradio-complex " + (!this.props.disabled ? "active " : "disabled ") + (this.props.rowClass || "")} onClick={this.radioClick}>
                <div className={"col " + (this.props.colClass || "")}>
                    <input type="radio" name={this.props.name} value={this.props.group} checked={this.props.value} readOnly />
                    <span className="checkmark"></span>
                    <h5 className={textClass[0] || ""}>{this.props.text[0]}</h5>
                    <h6 className={textClass[1] || ""}>{this.props.text[1]}</h6>
                </div>
            </div>
        );  
    }
}


/* onClick, name, rowClass, colClass, text, textClass
*/
export class ULink extends React.Component {
    constructor(props) {
        super(props);
        this.linkClick = this.linkClick.bind(this);
    }

    linkClick(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this.props.onClick(ev, this.props.name);
    }

    render() {
        return (
            <div className={"row ulink " + (this.props.rowClass || "")}>
                <div className={"col " + (this.props.colClass || "")}>
                    <a href="generic-link" onClick={this.linkClick}><h5 className={this.props.textClass || ""}>{this.props.text}</h5></a>
                </div>
            </div>
        );
    }
}


/* name, rowClass, colClass, value, pholder, onChange, disabled
*/
export class UDate extends React.Component {
    constructor(props) {
        super(props);
        this.changeValue = this.changeValue.bind(this);
    }

    changeValue(val) {
        if (this.props.disabled) return;
        this.props.onChange(null, this.props.name, dateStr(val));
    }

    render() {

        let input;
        if (!!this.props.disabled) input = (<input type="text" placeholder={this.props.pholder} value={this.props.value} disabled />);
        else {
            input = (<DatePicker minDate={this.props.minDate} maxDate={this.props.maxDate} dateFormat="dd/MM/yyyy" closeOnScroll={true} className={this.props.inputClass} placeholderText={this.props.pholder}
                locale={Languages.selectedLanguage} selected={dateObj(this.props.value)} onChange={this.changeValue} />);
        }

        return (
            <div className={"row udate " + (this.props.rowClass || "")}><div className="col">{input}</div></div>
        );
    }
}


//#endregion row Elements


//#region col Elements

/* colClass, textClass, text
*/
export function UTitleFlat(props) {
    return (
        <div className={"col utitleflat " + (props.colClass || "")}>
            <h5 className={props.textClass}>{props.text}</h5>
        </div>
    );
}


/* colClass, width, grow, textClass, value
*/
export function ULabelFlat(props) {
    let styleCol = {}, styleItem = {};
    if (props.style) Object.assign(styleItem, props.style);
    if (props.width) Object.assign(styleCol, { width: props.width, flex: (props.grow === false ? "0" : "1") + " 0 " + props.width });
    return (
        <div className={"col ulabelflat " + (props.colClass || "")} style={styleCol}>
            <h5 className={props.textClass} style={styleItem}>{props.value}</h5>
        </div>
    );
}


/* colClass, itemClass, width, grow, name, type, text, onClick
*/
export function UButtonFlat(props) {
    return (
        <div className={"col ubuttonflat " + (props.colClass || "")}
            style={(props.width ? { width: props.width, flex: (props.grow === false ? "0" : "1") + " 0 " + props.width } : null)}>
            <UButton disabled={props.hasOwnProperty("disabled") ? props.disabled:""} name={props.name} type={props.type} text={props.text} extraClass={props.itemClass} onClick={props.onClick} />
        </div>
    );
}


/* onClick, data{name, source, type, text, value}, ?colClass, ?width
*/
export function UListButtonFlat(props) {
    return (
        <div className={"col ulistbuttonflat " + (props.colClass || "")} style={(props.width ? { width: props.width, flex: "1 0 " + props.width } : null)}>
            <ListButton onClick={props.onClick} name={props.data.name} source={props.data.source} type={props.data.type} text={props.data.text} value={props.data.value} />
        </div>
    );
}


/* width, colClass, buttons[{name, type, source, text, click}]
*/
export function UButtonsGroupFlat(props) {
    const buttons = props.buttons.map((el, idx) => (
        <ListButton key={"btn-" + idx} type={el.type} name={el.name} source={el.source} text={el.text} onClick={el.click} />
    ));
    const colStyle = !props.width ? null : { width: props.width, flex: "1 0 " + props.width };
    return (
        <div className={"col ubuttonsgroupflat " + (props.colClass || "")} style={colStyle}>{buttons}</div>
    );
}


/* onClick, name, source, width, grow, colClass, text, textClass
*/
export class ULinkFlat extends React.Component {
    constructor(props) {
        super(props);
        this.linkClick = this.linkClick.bind(this);
    }

    linkClick(ev) {
        ev.preventDefault();
        ev.stopPropagation();
        this.props.onClick(ev, this.props.name, this.props.source);
    }

    render() {
        return <a href="#" onClick={this.linkClick}>{this.props.text}</a>;
    }

    /*render() {
        const style = (this.props.width ? { width: this.props.width, flex: (this.props.grow === false ? "0" : "1") + " 0 " + this.props.width } : { width: "auto" });
        return (
            <div className={"col ulinkflat " + (this.props.colClass || "")} style={style}>
                <a href="generic-link" onClick={this.linkClick}><h5 className={this.props.textClass || ""}>{this.props.text}</h5></a>
            </div>
        );
    }*/
}


/* name, source, width, colClass, inputClass, value, onChange
*/
export class UCheckboxFlat extends React.Component {
    constructor(props) {
        super(props);
        this.valChange = this.valChange.bind(this);
    }

    valChange(ev) {
        this.props.onChange(ev, this.props.name, ev.currentTarget.checked, this.props.source);
    }

    render() {
        const label = (!!this.props.label ? (<h5 className={this.props.label.class}>{this.props.label.text}</h5>) : null);
        return (
            <div className={"col ucheckboxflat " + (this.props.colClass || "")}
                style={(this.props.width ? { width: this.props.width, flex: "1 0 " + this.props.width } : { width: "auto" })}>
                {label}
                <input className={this.props.inputClass} type="checkbox" value={this.props.name} checked={this.props.value} onChange={this.valChange} />
            </div>
        );
    }
}


/* name, source, width, grow, colClass, itemClass, type, text, value, onChange, onKeyUp, onBlur
*/
export class UInputFlat extends React.Component {
    constructor(props) {
        super(props);
        this.valChange = this.valChange.bind(this);
        this.keyUp = this.keyUp.bind(this);
        this.blur = this.blur.bind(this);
        this.inputFocus = this.inputFocus.bind(this);
        this.input = React.createRef();
    }

    valChange(ev) {
        this.props.onChange(ev, this.props.name, ev.currentTarget.value, this.props.source);
    }

    keyUp(ev) {
        if (!!this.props.onKeyUp) this.props.onKeyUp(ev);
    }

    blur(ev) {
        if (!!this.props.onBlur) this.props.onBlur(ev);
    }

    inputFocus(ev) {
        if (!!this.input.current.focus) this.input.current.focus();
    }

    render() {
        const colStyle = this.props.width ? { width: this.props.width, flex: (this.props.grow === false ? "0" : "1") + " 0 " + this.props.width } : null;
        let className = this.props.error ? "col uinputflat error" : "col uinputflat";
        if (this.props.colClass)
            className = className + this.props.colClass;
        return (
            <div className={className} style={colStyle} onClick={this.inputFocus}>
                <input ref={this.input} className={this.props.itemClass} type={this.props.type || "text"} value={this.props.value}
                    placeholder={this.props.text} onChange={this.valChange} onKeyUp={this.keyUp} onBlur={this.blur} />
            </div>
        );
    }
}


/* name, source, width, grow, colClass, itemClass, text, value, onChange, disabled
*/
export class UDateFlat extends React.Component {
    constructor(props) {
        super(props);
        this.changeValue = this.changeValue.bind(this);
    }

    changeValue(val) {
        if (this.props.disabled) return;
        this.props.onChange(null, this.props.name, dateStr(val), this.props.source);
    }

    render() {
        const colStyle = this.props.width ? { width: this.props.width, flex: (this.props.grow === false ? "0" : "1") + " 0 " + this.props.width } : null;

        let input;
        if (!!this.props.disabled) input = (<input type="text" placeholder={this.props.text} value={this.props.value} disabled />);
        else {
            input = (<DatePicker maxDate={this.props.maxDate} dateFormat="dd/MM/yyyy" closeOnScroll={true} className={this.props.itemClass} placeholderText={this.props.text}
                locale={Languages.selectedLanguage} selected={dateObj(this.props.value)} onChange={this.changeValue} />);
        }

        return (
            <div className={"col udateflat " + (this.props.colClass || "")} style={colStyle}>{input}</div>
        );
    }
}


/* name, source, width, grow, colClass, className, options{value, text}, selection, onChange
*/
export class USelectFlat extends React.Component {
    constructor(props) {
        super(props);
        this.selChange = this.selChange.bind(this);
    }

    selChange(ev) {
        this.props.onChange(ev, this.props.name, ev.currentTarget.value, this.props.source);
    }

    render() {
        const options = this.props.options.map((el, idx) => (
            <option key={"opt-" + idx} value={el.value}>{el.text}</option>
        ));
        return (
            <div className={"col uselectflat " + (this.props.colClass || "")}
                style={(this.props.width ? { width: this.props.width, flex: (this.props.grow === false ? "0" : "1") + " 0 " + this.props.width } : null)}>
                <select className={this.props.className} onChange={this.selChange} value={this.props.selection}>{options}</select>
            </div>
        );
    }
}

//#endregion col Elements


//#region Extra Elements

/* type, onClick, colClass, value, name
*/
export class UAction extends React.Component {
    constructor(props) {
        super(props);
        let element, dt = new Date(), id = "UAction-" + props.type + "-" + dt.getTime();
        switch (props.type) {
            case 'load':
                element = (<input id={id} type="file" style={{ display: "none" }} />);
                break;
            case 'download':
            default:
                element = (<div id={id} style={{ display: "none" }} />);
                break;
        }

        this.element = { id: id, react: element };
        this.itemClick = this.itemClick.bind(this);
        this.fileChange = this.fileChange.bind(this);
    }

    //#region Events
    componentDidMount() {
        let elm = document.getElementById(this.element.id);
        if (this.props.type === 'load') {
            elm.addEventListener("click", this.catchClick);
            elm.addEventListener("change", this.fileChange);
        }
        this.element.dom = elm;
    }

    catchClick(ev) {
        ev.stopPropagation();
    }

    fileChange(ev) {
        this.props.onClick(ev, this.props.name, this.props.type, this.element.dom.files[0]);
        this.element.dom.value = null;
    }

    itemClick(ev) {
        let data = null;
        switch (this.props.type) {
            case 'load':
                console.debug("should click...");
                document.getElementById(this.element.id).click();
                break;
            case 'download':
                this.props.onClick(ev, this.props.name, this.props.type, data);
                break;
            default:
                break;
        }
    }
    //#endregion Events

    render() {
        return (
            <div className={"col uaction " + (this.props.colClass || "")}>
                <div className="uaction" onClick={this.itemClick}>{this.element.react}<h4>{this.props.value}</h4></div>
            </div>
        );
    }
}


export function UActionsGroup(props) {
    const actions = props.actions.map((el, idx) => (
        <UAction key={"action-" + idx} name={el.name} type={el.type} colClass={el.class} value={el.value} onClick={el.click} />
    ));
    return (<div className={"row uaction " + (props.rowClass || "")}>{actions}</div>);
}


/* name, active, title, type, text, value, onChange
*/
export class UAdditionalService extends React.Component {
    constructor(props) {
        super(props);
        this.dataChange = this.dataChange.bind(this);
        this.elementClick = this.elementClick.bind(this);
    }

    dataChange(ev, who, value) {
        who.unshift(this.props.name);
        this.props.onChange(ev, who, value);
    }

    elementClick(ev) {
        var who = ["active"];
        this.dataChange(ev, who, !this.props.active);
    }

    render() {
        const data = { error: this.props.hasOwnProperty("error") ? this.props.error:false, type: this.props.type, group: null, text: this.props.text, textClass: this.props.textClass, value: this.props.value, class: null };
        return (
            <div className={"col-6 additional-service input-section-small " + (this.props.active ? "active" : "disabled")}>
                <div className="row">
                    <div className="col">
                        {/* <UTitle action={{ text: this.props.title, class: "bold upper" }} onClick={this.elementClick} /> */}
                        <UTitle textClass="bold upper" text={this.props.title} />
                    </div>
                    <div className="col">
                        <UCheckbox rowClass="blue float-right" onChange={this.elementClick} />
                    </div>
                </div>
                <div className="horizontal-component" />
                <InputBox item="value" disabled={!this.props.active} data={data} onChange={this.dataChange} />
            </div>
        );
    }
}


/* title, totals[{name, amount, text}]
*/
export class UGrandTotals extends React.Component {
    render() {
        const items = this.props.totals.map((el, idx) => (
            <div key={el.name} name={el.name} className="ugrand-total-entry">
                <div className="row">
                    <div className="col">
                        <h1 className="ugrand-total white">{el.amount}</h1>
                        <h1 className="ugrand-total">{el.text}</h1>
                    </div>
                </div>
                <div className="row">
                    <div className="col">
                        <h5>{el.subText}</h5>
                        </div>
                </div>
            </div>
        ), this);
        return (
            <div className="container-fluid ugrand-totals">
                <UTitle textClass="bold upper" text={this.props.title} />
                {items}
            </div>
        );
    }
}


export class UGraphic extends React.Component {
    constructor(props) {
        super(props);
      
        this.canvas = React.createRef();
    }

    componentDidUpdate() {
        const sizeX = this.canvas.current.width = 1000;
        const sizeY = this.canvas.current.height = 500;
        const data = this.props.data;
       
        //const avg = !data.length ? 0 : (data.reduce((a, v) => (a + v), 0) / data.length);
        //const maxAbs = data.reduce((a, v) => (Math.max.apply(null, [a, Math.abs(v - avg)])), 0);
        //const dataout = data.map(v => (maxAbs==0?0:(v - avg) / maxAbs));

        //const maxAbs = Math.max.apply(null, data);
        const maxAbs = this.props.maxAbs;
        const dataout = data.map(v => (maxAbs == 0 ? 0 : v / maxAbs));

        var ctx = this.canvas.current.getContext("2d");

        const gradW = sizeX * 0.9 / dataout.length;
        const spc = sizeX * 0.1 / (dataout.length - 1);
        dataout.forEach((el, idx) => {
            const startH = (gradW + spc) * idx;
            //const endV = (-1 * el) * (sizeY / 2);

            const endV = (1-el)* sizeY;

            //let grd = ctx.createLinearGradient(startH, sizeY / 2, startH, sizeY / 2 + endV);

            //let grd = ctx.createLinearGradient(startH, 0, startH, 0 + endV);
            let grd = ctx.createLinearGradient(startH, endV, startH, sizeY * el);
            grd.addColorStop(0, 'rgba(249, 174, 49, 0)');
            grd.addColorStop(1, 'rgba(249, 174, 49, 1)');

            //ctx.fillStyle = grd;
            ctx.fillStyle = '#f9ae31';
            //ctx.fillRect(startH, 0, gradW, endV);
            ctx.fillRect(startH, endV, gradW, sizeY*el);
            //ctx.fillRect(startH, sizeY / 2, gradW, endV);
        });
    }

    render() {
        return (
            <div className="ugraphic">
                <canvas ref={this.canvas} style={this.props.canvasStyle} />
            </div>
        );
    }
}


//#endregion Extra Elements

//#endregion Basic Utilities


//#region UCard
export function UCardTitle(props) {
    return (
        <div className={"widget-content-title " + props.textClass}>{props.text}</div>
    );
}


export function UCardImage(props) {
    return (
        <div className="row ucard-image"><div className="col"><img src={props.image} alt="" /></div></div>
    );
}


/* props: (img.src)logo
 * class: ucard-logo
*/
export function UCardLogo(props) {
    return (
        <div className={"row ucard-logo bg-white " + (props.rowClass || "")}><div className="col"><img src={props.logo} alt="" /></div></div>
    );
}


export function UCardInfo(props) {
    return (
        <div className="row ucard-info"><div className="col"><h5 className={props.textClass}>{props.text}</h5></div></div>
    );
}


/* props: (h6)text
 * class: ucard-detail
*/
export function UCardDetail(props) {
    return (
        <div className="row ucard-detail"><div className={"col " + (props.colClass || "")}><h6 className={props.textClass}>{props.text}</h6></div></div>
    );
}
//#endregion UCard


//#region LogoList

export class LogoListCard extends React.Component {
    constructor(props) {
        super(props);
        this.ucardClick = this.ucardClick.bind(this);
    }

    ucardClick(ev) {
        this.props.onClick(ev, this.props.name, this.props.id);
    }

    render() {
        return (
            <div className="container" onClick={this.ucardClick}>
                <UCardLogo rowClass={this.props.rowClass} logo={this.props.logo} />
                <UCardDetail text={this.props.name} colClass="no-padding" />
            </div>
        );
    }
}


export class LogoList extends React.Component {
    constructor(props) {
        super(props);
        this.state = { searchString: '' };
        this.searchChange = this.searchChange.bind(this);
    }

    searchChange(ev) {
        this.setState({ searchString: ev.target.value });
    }

    render() {
        let rows = [], cols = [], maxItemsInRow = 4, items = this.props.list.slice();
        for (let key = 0; key < items.length; key++) {
            if (items[key].name.toLowerCase().indexOf(this.state.searchString.toLowerCase()) > -1) {
                cols.push(<div key={"col-" + key} className="minimum">
                    <LogoListCard key={"cc-" + key} rowClass={items[key].configured ? "configured" : ""} id={items[key].id}  name={items[key].name} logo={items[key].logo} onClick={this.props.onClick} />
                </div>);
                if (cols.length === maxItemsInRow) {
                    rows.push(<div key={"row-" + rows.length} className="row logo-list-row">{cols}</div>);
                    rows.push(<div key={"row-" + rows.length} style={{ marginTop: "2rem" }} />);
                    cols = [];
                }
            }
        }
        if (cols.length) {  // residuals
            const colSize = "maximum";
            const calc = cols.length === 2 ? "44.5%" : "17%";
            cols.push(<div key={"col-fill"} className={colSize} style={{ width: calc }} />);
            rows.push(<div key={"row-" + rows.length} className="row logo-list-row">{cols}</div>);
            rows.push(<div key={"row-" + rows.length} style={{ marginTop: "2rem" }} />);
        }

        return (
            <div className="container ucard">
                <UCardTitle text={this.props.title} />
                {!this.props.paragraph ? null : <UParagraph colClass="" textClass="" value={this.props.paragraph} />}
                {!this.props.paragraph ? null : <div style={{ marginTop: "2.5rem" }} />}
                <USearch rowClass={this.props.searchClass} search={this.props.search} value={this.state.searchString} onChange={this.searchChange} />
                {rows}
            </div>
        );
    }
}


export class LogoListWide extends React.Component {
    constructor(props) {
        super(props);
        this.fileClick = this.fileClick.bind(this);
        this.fileChange = this.fileChange.bind(this);
    }
    fileClick(ev, name) {

        document.getElementById(name + "-file").click();
        
    }
    fileChange(ev) {

        let el = ev.target;
        if (el != null) {
            this.props.onClick(ev, el.getAttribute("marketname"), "file",
                el.files[0]);
         
        }

    }
    render() {
        let rows = [], cols = [], maxItemsInRow = 10, items = this.props.list.slice();
        
        //#region computing ROWS
        for (let key = 0; key < items.length; key++) {
            let hasInputFile = items[key].hasOwnProperty("file") && items[key].file;
            let inputFile = "";
            if (hasInputFile)
                inputFile = (<input onChange={this.fileChange} marketname={items[key].name} id={items[key].name + "-file"} type="file" style={{ display: "none" }} />);
            cols.push(<div key={"col-" + key} className="minimum">
                <LogoListCard key={"cc-" + key} rowClass={items[key].configured ? "configured" : ""}
                    name={items[key].name} logo={items[key].logo}
                    onClick={!hasInputFile ? this.props.onClick : this.fileClick} />
                {inputFile}
            </div>);
            if (cols.length === maxItemsInRow) {
                rows.push(<div key={"row-" + rows.length} className="row logo-list-row">{cols}</div>);
                rows.push(<div key={"row-" + rows.length} style={{ marginTop: "2rem" }} />);
                cols = [];
            }
        }
        if (cols.length) {  // residuals
            const colClass = "maximum";
            const calc = (10 * (maxItemsInRow - cols.length)).toString() + "%";
            cols.push(<div key={"col-fill"} className={colClass} style={{ width: calc }} />);
            rows.push(<div key={"row-" + rows.length} className="row logo-list-row">{cols}</div>);
            rows.push(<div key={"row-" + rows.length} style={{ marginTop: "2rem" }} />);
        }
        //#endregion computing ROWS 

        return (
            <div className="container-fluid ucard">
                <UCardTitle text={this.props.title} />
                <UActionsGroup rowClass="" actions={this.props.actions} />
                {rows}
            </div>
        );
    }
}

//#endregion LogoList


//#region ConfiguratedList
export function ListRowEntryName(props) {
    return (
        <div className="col list-entry-name" style={{ width: props.width, flex: "1 0 " + props.width }}>
            {!props.icon ? [] : <img src={props.icon} alt="" />}
            <h6>{props.name}</h6>
        </div>
    );
}


export function ListRowEntryFlag(props) {
    return (
        <div className={"col list-entry-flag " + (props.colClass || "")} style={{ width: props.width, flex: "1 0 " + props.width }}>
            <div className={"flag" + (props.active ? " active" : "")} />
        </div>
    );
}


export function ListRowEntryButtonsGroup(props) {
    const buttons = props.buttons.map((el, idx) => (
        <ListButton key={"btn-" + idx} type={el.type} name={el.name} source={el.reference} text={el.text} onClick={el.click} />
    ));
    return (
        <div className="col list-entry-buttons" style={{ width: props.width, flex: "1 0 " + props.width }}>{buttons}</div>
    );
}


export function ListRowEntry(props) {
    //console.debug("ListRowEntry props.buttons: " + JSON.stringify(props.buttons));
    const buttons = props.buttons.map((el, idx) => (Object.assign({ reference: props.reference }, el)));
    //console.debug("ListRowEntry buttons: " + JSON.stringify(buttons));
    return (
        <div>
            <div className={"row list-entry " + (props.rowClass || "")}>
                <ListRowEntryName class={props.classes[0]} icon={props.icon} width={props.width[0]} name={props.name} />
                <ListRowEntryFlag class={props.classes[1]} width={props.width[1]} active={props.active} />
                <ListRowEntryButtonsGroup class={props.classes[2]} width={props.width[2]} buttons={buttons} />
            </div>
        </div>
    );
}


export class ConfiguratedList extends React.Component {
    render() {
        let widths = [], classes = [];
        const columns = this.props.columns.map(function (el, idx) {
            widths.push(el.width);
            classes.push(el.class); 
            return <div key={'col-' + idx} className="col" style={{ width: el.width, flex: "1 0 " + el.width }}>
                <h6 className={"bold " + (el.class || "")}>{el.caption}</h6>
            </div>;
        });

        const entries = Object.entries(this.props.entries).map(([key, value], idx) => (
            <ListRowEntry key={'re-' + key}
                name={value.hasOwnProperty("name") ? value.name : key}
                icon={!value.icon ? false : value.icon}
                rowClass={this.props.entryRowClass}
                width={widths}
                reference={key}
                active={value.flag} 
                classes={classes} buttons={this.props.buttons} />
        ));

        return (
            <div>
                <div class="row">{columns}</div>
                {entries}
            </div>
        );
    }
}
//#endregion ConfiguratedList


//#region Input Boxes

/* name, class, title, text
*/
export class LabelBox extends React.Component {
    render() {
        return (
            <div className={"container label-box " + (this.props.class || "")}>
                <div className="row">
                    <div className="col"><h6 className="title">{this.props.title}</h6></div>
                </div>
                <div className="row">
                    <div className="col"><h6>{this.props.text}</h6></div>
                </div>
            </div>
        );
    }
}


/* data{width, type, text, value, class}, item, padding, onChange
*/
export class InputBoxFlat extends React.Component {
    constructor(props) {
        super(props);
        this.changeValue = this.changeValue.bind(this);
        this.inputFocus = this.inputFocus.bind(this);
        this.input = React.createRef();
    }

    changeValue(ev) {
        var who = (this.props.item.indexOf(".") > -1) ? this.props.item.split(".") : [this.props.item];
        this.props.onChange(ev, who, ev.target.value);
    }

    inputFocus(ev) {
        if (!!this.input.current.focus) this.input.current.focus();
    }

    render() {
        const colStyle = !this.props.data.width ? null : { width: this.props.data.width, flex: "1 0 " + this.props.data.width };
        const padding = (!!this.props.padding || (this.props.padding === undefined));
        let className = this.props.data.error ? "col input-box type-flat error " : "col input-box type-flat ";
        if (this.props.data.class)
            className = className + this.props.data.class;
        return (
            <div className={className} style={colStyle} onClick={this.inputFocus}>
                <div className="row">
                    <div className={"col" + (padding ? "" : " no-padding")}><h6>{this.props.data.text}</h6></div>
                </div>
                <div className="row">
                    <div className={"col" + (padding ? "" : " no-padding")}>
                        <input ref={this.input} type={this.props.data.type} value={this.props.data.value} onChange={this.changeValue} />
                    </div>
                </div>
            </div>
        );
    }
}


/* data{type, group, textClass, text, value, class}, item, onChange, disabled
*/
export class InputBox extends React.Component {
    constructor(props) {
        super(props);
        this.changeValue = this.changeValue.bind(this);
        this.autocompletePlaceSelected = this.autocompletePlaceSelected.bind(this);
        this.autocompleteChange = this.autocompleteChange.bind(this);

        this.autocompleteCountryChange = this.autocompleteCountryChange.bind(this);
        this.autocompleteCountrySelected = this.autocompleteCountrySelected.bind(this);

        this.onSelectCountryChange = this.onSelectCountryChange.bind(this)
        this.autocompleteSelected = this.autocompleteSelected.bind(this);
        this.keyUp = this.keyUp.bind(this);
        this.radioClick = this.radioClick.bind(this);
        this.inputFocus = this.inputFocus.bind(this);
        this.input = React.createRef();
     
    }

    changeValue(ev) {
        if (this.props.disabled) return;
        const value = (this.props.data.type === "radio" ? ev.checked : (this.props.data.type === "date" ? dateStr(ev) : ev.target.value));
        var who = [this.props.item];
        this.props.onChange(ev, who, value, this.props.data.id ? this.props.data.id : '');
    }
    
    autocompleteChange(ev) {
        if (this.props.onAutocompleteChange) {
            let who = [this.props.item];
            this.props.onAutocompleteChange(who, ev.target.value);
        }
    }
    autocompleteSelected(val, items) {
        if (this.props.onAutocompleteSelected) {
            let who = [this.props.item];
            this.props.onAutocompleteSelected(who, items);
        }
    }

    autocompleteCountryChange(ev) {
        if (this.props.onAutocompleteCountryChange) {
            let who = [this.props.item];
            this.props.onAutocompleteCountryChange(who, ev.target.value);
        }
    }
    
    autocompleteCountrySelected(items) {
        if (this.props.onAutocompleteCountrySelected) {
            const val = items.label
            const countryCode = items.countryCode;
            let who = [this.props.item];
            this.props.onAutocompleteCountrySelected(who, val, countryCode);
        }
    }


    onSelectCountryChange(ev, _orderIndex, _fieldName,  countryName, countryCode, source, isCountryEu, isVisibleExtraEu) {
        let who = [this.props.item];
        this.props.onAutocompleteCountryChange(who, countryName,  countryCode, source, isCountryEu, isVisibleExtraEu);
    }




    autocompletePlaceSelected(place,dict) {
        let who = [this.props.item];

        
        let arr = ['premise', 'route', 'locality', 'postal_town', 'administrative_area_level_2', 'postal_code', 'country'];
        if (!dict)
            dict = {};
        if (place.address_components && place.address_components.length)
            for (let i = 0; i < place.address_components.length; i++)
                for (let j = 0; j < place.address_components[i].types.length; j++)
                    if (arr.indexOf(place.address_components[i].types[j]>-1))
                        dict[place.address_components[i].types[j]] = place.address_components[i]["short_name"];
                        
        if (this.props.onAutocompletePlaceSelected)
            this.props.onAutocompletePlaceSelected(who, place, dict);
        
    }
    keyUp(ev) {
        if (this.props.disabled || !this.props.onKeyUp) return;
        var who = [this.props.item];
        this.props.onKeyUp(ev, who);
    }

    radioClick(ev) {
        if (this.props.disabled) return;
        const radio = ev.currentTarget.childNodes[0];
        if (!radio.checked) 
            radio.checked = true;
        this.changeValue(radio);
        
    }

    inputFocus(ev) {
        if (this.input.current!=null && !!this.input.current.focus) this.input.current.focus();
    }

    render() {
        let disabled = this.props.data.disabled ? this.props.data.disabled : false;
        let mandatory = this.props.data.mandatory || false;
        let iFldCls = this.props.data.error ? " input-field-error " : "";
        let iEleCls = '';
        if (this.props.data.type === 'radio') {
            iEleCls = ' input-radio';
            return (
                <div className={"input-element " + iEleCls + (this.props.data.class ? this.props.data.class : "") + (mandatory ? ' mandatory': '')}>
                    <div className={"input-field " + iFldCls} onClick={this.radioClick}>
                        <input disabled={disabled} type={this.props.data.type} name={this.props.data.group} value={this.props.data.text} checked={this.props.data.value} readOnly />
                        <div className={'input-label ' + (this.props.data.textClass ? this.props.data.textClass : '')}>{this.props.data.text}</div>
                    </div>
                </div>
            );
        }

        
        let input;
        if (!!this.props.disabled && this.props.data.type === 'text') input = (<input type={this.props.data.type} value={this.props.data.value} disabled />);
        else if (this.props.data.type === 'date') {
            input = (<DatePicker disabled={disabled} ref={this.input} dateFormat="dd/MM/yyyy" closeOnScroll={true}
                locale={Languages.selectedLanguage} selected={dateObj(this.props.data.value)} onChange={this.changeValue} />);
        }
        else if(this.props.data.type === 'selectField') {
            input = <SelectField
                            key={this.props.data.id}
                            name={this.props.data.id}
                            source={this.props.data.source}
                            className="uselect"
                            hasDefaultClass={false}
                            options={this.props.data.options.flat(1)} 
                            value={this.props.data.value}
                            onSelectChange={this.onSelectCountryChange} /> ;
        }

        else if (this.props.data.type === 'select') {
            input = (<USelect 
                key={this.props.data.id}
                name={this.props.data.id}
                source="pickupAddress"
                colClass=""
                className=""
                options={this.props.data.options} 
                selection={this.props.data.value}
                disabled={disabled}
                onChange={this.changeValue} />);
        }
        else if (this.props.data.type === 'google-place-autocomplete-old') {
            input = (<GoogleAutocomplete
                apiKey="AIzaSyC77hx3YU-12HVvLpGJPH79amsjc55upuA"
                style={{ width: '90%' }}
                onPlaceSelected={(place) => {
                    
                    this.autocompletePlaceSelected(place);
                   
                }}
                defaultValue={this.props.data.value }
                types={['address']}
                componentRestrictions={{ country: "it" }}
            />);
        }
        else if (this.props.data.type === 'google-place-autocomplete') {
            input = (<SearchLocationInput defaultValue={this.props.data.value} onPlaceSelected={this.autocompletePlaceSelected} onChange={() => null} />
            );
        }
        
        
        else if (this.props.data.type === 'autocomplete') {
            input = (<Autocomplete
                getItemValue={(item) => item.label}
                items={this.props.data.options.flat(1)}
                renderMenu={children => (
                    <div key={this.props.data.value} className="autocomplete-menu menu-city">
                        {children}
                    </div>
                )}
                renderItem={(item, isHighlighted) =>
                    <div key={item.id} className={"item " + (isHighlighted ? 'hilighted' : '')}>
                        {item.label}
                    </div>
                }
                value={this.props.data.value}
                onChange={this.autocompleteChange}
                onSelect={(val, items) => this.autocompleteSelected(val, items)}
            />);
        }
        else if(this.props.data.type === "autocomplete-country") {
            input = (<Autocomplete
                getItemValue={(item) => item.label}
                items={this.props.data.options.flat(1)}
                renderMenu={children => (
                    <div className="autocomplete-menu menu-country">
                        {children}
                    </div>
                )}
                renderItem={(item, isHighlighted) =>
                    <div key={item.label} className={"item " + (isHighlighted ? 'hilighted' : '')}>
                        {item.label}
                    </div>
                }
                value={this.props.data.value}
                onChange={this.autocompleteCountryChange}
                onSelect={(val, items) => this.autocompleteCountrySelected(items)}
            />);
        }
        else if (disabled) {
            input = (<label>{this.props.data.value}</label>);

        }
        else input = (<input disabled={disabled} maxLength={this.props.data.hasOwnProperty("maxLength") ? this.props.data.maxLength:200} ref={this.input} type={this.props.data.type} value={this.props.data.value} onChange={this.changeValue} onKeyUp={this.keyUp} />);
                
        return <div className={"input-element " + (this.props.data.class ? this.props.data.class : "") + (mandatory ? ' mandatory' : '')} onClick={this.inputFocus}>
            <div className={'input-label ' + (this.props.data.textClass ? this.props.data.textClass : '')}>{this.props.data.text}</div>
            <div className={"input-field " + iFldCls}>{input}</div>
        </div>;
        

        /*return (
            <div className={className} onClick={this.inputFocus}>
                <div className="row">
                    <div className="col"><h6 className={this.props.data.textClass}>{this.props.data.text}<span> {mandatory}</span></h6></div>
                </div>
                <div className="row"><div className="col">{input}</div></div>
            </div>
        );*/
    }
}


/* This component draws a section of InputBox configured into this.props.data.items
 * this.props.data.rowsize is the maximum size of a row
 * this.props.data.itemunit is the maximum size of a InputBox
 * each item has his own size
 * 
 * column, onChange, title{rowClass, colClass, value}, data { rowsize, itemunit, items { id, size, text, type, value } }
*/
export class InputColumn extends React.Component {
    constructor(props) {
        super(props);
        this.changeValue = this.changeValue.bind(this);
        this.onAutocompletePlaceSelected = this.onAutocompletePlaceSelected.bind(this);
        this.onAutocompleteChange = this.onAutocompleteChange.bind(this);
        this.onAutocompleteSelected = this.onAutocompleteSelected.bind(this);
        this.onAutocompleteCountryChange = this.onAutocompleteCountryChange.bind(this);
        this.onAutocompleteCountrySelected = this.onAutocompleteCountrySelected.bind(this);
    }

    changeValue(ev, who, val,id) {
        if (this.props.onChange) {
            who.unshift(this.props.column);

            this.props.onChange(ev, who, val, id);
        }
    }
    onAutocompletePlaceSelected( who, val,dict) {
        who.unshift(this.props.column);
       
        this.props.onAutocompletePlaceSelected( who, val,dict);
    }

// who, countryName,  countryId, source
    onAutocompleteCountryChange(who, val, countryCode, source, isCountryEu, isVisibleExtraEu) {
        if (this.props.onAutocompleteCountryChange) {
            who.unshift(this.props.column);
            // debugger
            this.props.onAutocompleteCountryChange(who, val, countryCode, source, isCountryEu, isVisibleExtraEu);
        }
    }

    onAutocompleteCountrySelected(who, val, countryCode) {
        if (this.props.onAutocompleteCountrySelected) {
            who.unshift(this.props.column);
            this.props.onAutocompleteCountrySelected(who, val, countryCode);
        }
    }


    onAutocompleteChange(who, val) {
        if (this.props.onAutocompleteChange) {
            who.unshift(this.props.column);
            this.props.onAutocompleteChange(who, val);
        }
    }
    onAutocompleteSelected(who, items) {
        if (this.props.onAutocompleteSelected) {
            who.unshift(this.props.column);
            this.props.onAutocompleteSelected(who, items);
        }
    }
    render() {

        let elements = [];
        let group = null;
        let groupElements = [];
        let key;
        for (key = 0; key < this.props.data.items.length; key++) {
            const itemDef = this.props.data.items[key];
            if (itemDef.group != group && group) {
                elements.push(<div key={'ig1-' + key} className={'input-group ' + group}>{groupElements}</div>);
                group = null;
                groupElements = [];
            }

            let element = <InputBox 
                key={'ig2-' + key}
                onAutocompleteSelected={this.onAutocompleteSelected} 
                onAutocompleteChange={this.onAutocompleteChange}
                onAutocompletePlaceSelected={this.onAutocompletePlaceSelected}
                onAutocompleteCountryChange={this.onAutocompleteCountryChange}
                onAutocompleteCountrySelected={this.onAutocompleteCountrySelected}
                disabled={itemDef?.disabled}
                item={key}
                data={itemDef}
                onChange={this.changeValue} />;

            if (itemDef.group) {
                group = itemDef.group;
                groupElements.push(element);
            }
            else {
                elements.push(<div key={'ig3-' + key} className={'input-group'}>{ element }</div>);
            }
        }

        if (group) {
            elements.push(<div key={'ig4-' + key} className={'input-group ' + group}>{groupElements}</div>);
        }
            

        let buttons = [];
        for (let key = 0; this.props.data.buttons && key < this.props.data.buttons.length; key++) {
                buttons.push(<UButton key={"btn-" + key} 
                type={this.props.data.buttons[key].type}
                text={this.props.data.buttons[key].text}
                onClick={this.props.data.buttons[key].click} />);
        }
        if (buttons.length) {
            elements.push(<div key={'ig5-' + key} className={'input-group buttons'}>{buttons}</div>);
        }

        return elements;
    }
}


export class InputSection extends React.Component {
    constructor(props) {
        super(props);
        this.changeValue = this.changeValue.bind(this);
        this.onAutocompletePlaceSelected = this.onAutocompletePlaceSelected.bind(this);
        this.onAutocompleteChange = this.onAutocompleteChange.bind(this);
        this.onAutocompleteCountryChange = this.onAutocompleteCountryChange.bind(this);
        this.onAutocompleteSelected = this.onAutocompleteSelected.bind(this);
        this.onAutocompleteCountrySelected = this.onAutocompleteCountrySelected.bind(this)
    }

    onAutocompletePlaceSelected(who, val, dict) {
        who.unshift(this.props.section);
        this.props.onAutocompletePlaceSelected(who, val, dict);
    }
    onAutocompleteChange(who, val) {
        if (this.props.onAutocompleteChange) {
            who.unshift(this.props.section);

            this.props.onAutocompleteChange(who, val);
        }
    }
    onAutocompleteSelected(who, items) {
        if (this.props.onAutocompleteSelected) {
            who.unshift(this.props.section);
            this.props.onAutocompleteSelected(who, items);
        }
    }

    changeValue(ev, who, val) {
        who.unshift(this.props.section);
        this.props.onChange(ev, who, val);
    }

    onAutocompleteCountrySelected(who, val, countryId) {
        if (this.props.onAutocompleteCountrySelected) {
            who.unshift(this.props.section);
            this.props.onAutocompleteCountrySelected(who, val, countryId);
        }
    }
// who, countryName,  countryId, source
    onAutocompleteCountryChange(who, val, countryCode, source, isCountryEu, isVisibleExtraEu) {
        if (this.props.onAutocompleteCountryChange) {
            who.unshift(this.props.section);
            this.props.onAutocompleteCountryChange(who, val, countryCode, source, isCountryEu, isVisibleExtraEu);
        }
    }

    render() { 
        //const mainClass = (this.props.data.class || ("container-fluid input-section ucard " + (this.props.data.extraClass || "")));
        const columns = this.props.data.columns.map((el, idx) => {
            return (<InputColumn
                onAutocompleteSelected={this.onAutocompleteSelected}
                onAutocompleteChange={this.onAutocompleteChange}
                onAutocompletePlaceSelected={this.onAutocompletePlaceSelected}
                onAutocompleteCountrySelected={this.onAutocompleteCountrySelected}
                onAutocompleteCountryChange={this.onAutocompleteCountryChange}
                key={'col-' + idx}
                column={idx}
                data={el}
                onChange={this.changeValue} />)
        });

        const renderBtns = !!this.props.data.buttons && !!this.props.data.buttons.length;

        const buttons = !renderBtns ? null : this.props.data.buttons.map((el, idx) => {
            return (<UButton key={"btn-" + idx} type={el.type} text={el.text} onClick={el.click} />);
        });

        let titleRowClass = "row section-title"
        let titleColClass = "col"
        let title = this.props.data.title;
        let invoiceMessage = this.props.data.invoiceMessage;
        let mandatoryMessage = this.props.data.mandatoryMessage;
        // let triangulationCSSClass = this.props.shouldShowTriangolationSection ? 'show': 'hide'

        if (typeof title === "object") { titleRowClass += " " + title.rowClass; titleColClass += " " + title.colClass; title = title.value; }

        if (this.props.splitColumns) {
            return [columns.map((column, idx) => {

               if(idx === 0) {
                    return <div key={"wid-" + idx} className={"widget " + (this.props.shouldShowTriangolationSection ? 'show' : 'hide')}>
                        <div className="widget-header">{column.props.data.title.value}</div>
                        <div className="widget-content">
                            {column}
                            <small className="foot-print-note section-hint ellipsis">{Languages.getSection('UserProfile').mandatoryHint}</small>
                        </div>
                    </div>
               }
                return (
                    <div key={"wid-" + idx} className={"widget " + (this.props.data.class ? this.props.data.class : '')}>
                        <div className="widget-header">{column.props.data.title.value}</div>
                        <div className="widget-content">
                            {column}
                            <small className="foot-print-note section-hint ellipsis">{Languages.getSection('UserProfile').mandatoryHint}</small>
                        </div>
                    </div>
                )
            }, this), buttons];
        } else {           
            return  <div className={"widget user-profile-input-section " + (this.props.data.class ? this.props.data.class : '')}>         
                <div className="widget-header">{title}</div>
                <div className="widget-content">
                    {columns}
                    {buttons}            
                    <small className="foot-print-note section-hint ellipsis">{mandatoryMessage}</small>
                    <small className="foot-print-note section-hint ellipsis">{invoiceMessage}</small>
                </div>
            </div>;
        }
    }
}

//#endregion Input Boxes


//#region UItemsList

// listId, listKey
// header[{}] = caption{}, element{}
// entries[[]] = only values
// managers[[]] = values of manage columns
// navigation = pageSize: { text: value: change: }, pageNo: { value: change: }, totalItems: { value: }
export class UItemsList extends React.Component {
    constructor(props) {
        super(props);

        this.navigationChange = this.navigationChange.bind(this);
        this.keyUp = this.keyUp.bind(this);
        this.pageChange = this.pageChange.bind(this);
        this.lostFocus = this.lostFocus.bind(this);
        this.sizeChange = this.sizeChange.bind(this);
        this.refresh = this.refresh.bind(this);
       
        this.currentPage = (!props.navigation) ? 0 : (props.navigation.pageNo.value + 1);

        this.state = {
            inputPage: this.currentPage.toString(),
            totPages: this.calculateTotPages(),
            pageSize: (!props.navigation) ? "0" : (props.navigation.pageSize.value)
        };
    }

    calculateTotPages() {
        if (!this.props.navigation ||
            !this.props.navigation.hasOwnProperty("totalItems")
            || this.props.navigation.totalItems == 0) return 0;

        let tp = this.props.navigation.totalItems.value / this.props.navigation.pageSize.value;
        if (tp - Math.floor(tp) > 0) tp = Math.floor(tp) + 1;
        return (tp === 0) ? 1 : tp;
    }

    componentDidUpdate() {
        if (!!this.props.navigation) {
            const tp = this.calculateTotPages();
            if (this.state.totPages !== tp) this.setState({ totPages: tp });

            if (this.state.pageSize !== this.props.navigation.pageSize.value)
                this.setState({ pageSize: this.props.navigation.pageSize.value });

            if (this.currentPage !== (this.props.navigation.pageNo.value + 1)) {
                this.currentPage = (this.props.navigation.pageNo.value + 1);
                this.setState({ inputPage: this.currentPage.toString() });
            }
        }
    }

    navigationChange(ev, nm, vl) {
        if (typeof vl !== 'number' || !isFinite(vl)) vl = this.currentPage - 1;
        switch (nm) {
            case "first":
                vl = 0;
                break;
            case "previous":
            case "pageNo":
                vl -= 1;
                break;
            case "next":
                vl += 1;
                break;
            case "last":
                vl = this.state.totPages - 1;
                break;
            default:
                break;
        }

        if (vl < 0) vl = 0;
        if (vl > this.state.totPages - 1) vl = this.state.totPages - 1;

        if (vl !== this.currentPage - 1) this.props.navigation.pageNo.change(ev, vl);
        else this.setState({ inputPage: this.currentPage.toString() });
    }

    sizeChange(ev, name, value, source) {
        //if (value !== this.props.navigation.pageSize.value && value < this.props.navigation.totalItems.value) this.props.navigation.pageSize.change(ev, value);
        //else this.setState({ pageSize: value });
        if (value !== this.props.navigation.pageSize.value)
            this.props.navigation.pageSize.change(ev, value);
        this.setState({ pageSize: value });
    }

    pageChange(ev) {
        let vl = ev.currentTarget.value;
        this.setState({ inputPage: vl });
    }

    lostFocus(ev) {
        let vl = parseInt(ev.currentTarget.value);
        if (this.currentPage !== vl)
            this.navigationChange(ev, "pageNo", isNaN(vl) ? 0 : vl);
    }

    keyUp(ev) {
        if (ev.keyCode === 13) {
            let vl = parseInt(ev.currentTarget.value);
            if (this.currentPage !== vl)
                this.navigationChange(ev, "pageNo", isNaN(vl) ? 0 : vl);
        }
    }
    
    refresh(ev) {
        if (typeof this.props.navigation.refresh === "function") this.props.navigation.refresh(ev, "refresh");
    }

    render() {
        let isExecuting = this.props.hasOwnProperty("isExecuting") && this.props.isExecuting ? true : false;
        const lk = this.props.listKey, md = this.props.managers, headerSource = "##header##";
        let mngCount = 0, navigation = (<div />);
        const captions = this.props.header.map(function (el, idx) {
            

            const mng = el.generic.manage, width = el.generic.width.toString() + "%", key = "head-" + idx.toString(),
                nm = el.generic.name, cClass = el.caption.colClass, iClass = el.caption.itemClass;
            let col = [];
            switch (el.caption.type) {
                case "checkbox":
                    
                    const label = (!!el.caption.value ? { class: el.caption.textClass, text: el.caption.value } : null);
                    col.push(<UCheckboxFlat key={key} name={nm} source={headerSource} width={width} colClass={cClass} inputClass={iClass}
                        value={!!mng ? md[0][mngCount++] : el.caption.value} label={label} onChange={el.generic.change} />);
                    break;
                case "label":
                    col.push(<ULabelFlat key={key} width={width} colClass={cClass} textClass={iClass} value={el.caption.value} />);
                    break;
                case "hidden":
                    break;
                default:
                    col.push(<div key={key} className="col" style={{ width: width }}>{"unrecognized " + el.caption.type}</div>);
                    break;
            };
            return col;
        });
        let entries;
        if (isExecuting)
            entries = (<div> Ordine in elaborazione </div>);
        else
        entries = this.props.entries.map(function (row, rownum) {
            mngCount = 0;
            const cols = this.props.header.map(function (el, idx) {
                const mng = el.generic.manage, width = el.generic.width.toString() + "%", key = "col-" + idx.toString(), nm = el.generic.name;
                let col, val, style = null, cClass = el.element.colClass, exVal = null;
                let iClass = el.element.hasOwnProperty("itemClassFunc") ? el.element.itemClassFunc() : el.element.itemClass;
                switch (el.element.type) {
                    case "hidden":
                        break;
                    case "checkbox":
                        const label = (!!el.element.value ? { class: el.element.textClass, text: el.element.value } : null);
                        val = (!!mng ? md[rownum + 1][mngCount++] : row[idx - mngCount]);
                        col = (<UCheckboxFlat key={key} name={nm} source={row[lk]} label={label}
                            width={width} colClass={cClass} inputClass={iClass} value={val} onChange={el.generic.change} />);
                        break;
                    case "label":
                        //console.debug(`name: ${nm}, mng: ${mng}, value: ${!mng ? (typeof row[idx - mngCount]) : "managed"}`);
                        if (!!mng) val = md[rownum + 1][mngCount++];
                        else if (row[idx - mngCount] == null)
                            val = "";
                        else if (typeof row[idx - mngCount] === "string") val = row[idx - mngCount];
                        else {
                            val = row[idx - mngCount].val;
                            style = { color: row[idx - mngCount].color };
                        };
                        
                        col = (<ULabelFlat key={key} width={width} colClass={cClass} textClass={iClass} style={style} value={val} />);
                        break;
                    case "select":
                        val = (!!mng ? md[rownum + 1][mngCount++] : row[idx - mngCount]);
                        col = (<USelectFlat key={key} name={nm} source={row[lk]} width={width} colClass={cClass} className={iClass}
                            options={el.element.options} selection={val} onChange={el.generic.change} />);
                        break;
                    case "link":
                        val = (!!mng ? md[rownum + 1][mngCount++] : row[idx - mngCount]);
                        col = (<ULinkFlat key={key} name={nm} source={row[lk]} width={width} colClass={cClass} textName={iClass} text={val} onClick={el.generic.click} />);
                        break;
                    case "button":
                        
                        if (mng === 2 && !row[idx - mngCount]) cClass += " hidden";
                        if (mng === 3) exVal = row[idx - mngCount];
                        if (mng === 4)
                        {
                            val = row[idx - mngCount].label;
                           
                            if (row[idx - mngCount].hasOwnProperty("class"))
                                iClass = iClass + " " + row[idx - mngCount].class;
                            exVal = row[idx - mngCount].value;
                        }
                        else
                            val = (!!mng ? el.element.options : row[idx - mngCount]);
                        if (val != null && val != "")
                            col = (<UListButtonFlat style={style} key={key} width={width} colClass={cClass} onClick={el.generic.click}
                                data={{ name: nm, source: row[lk], type: iClass, text: val, value: exVal }} />);
                        else
                            col = (<ULabelFlat key={key} width={width} colClass={cClass} textClass={iClass} style={style} value={""} />);
                        mngCount += (!!mng ? 1 : 0);
                        break;
                    case "buttons-group": // buttons[{name, type, source, text, click}]
                        val = (!!mng ? el.element.options : row[idx - mngCount]);
                        const buttons = val.map((txt, idx) => ({ name: el.generic.name, type: el.element.itemClass[idx], source: row[lk], text: txt, click: el.generic.click }));
                        col = (<UButtonsGroupFlat key={key} width={width} colClass={cClass} buttons={buttons} />);
                        mngCount += (!!mng ? 1 : 0);
                        break;
                    case "dot":
                        val = row[idx - mngCount];
                        mngCount += (!!mng ? 1 : 0);
                        let cName = (val == '' ? iClass : val);
                        col = (<div key={key} className="col" style={{ width: width }}><span className={cName}></span></div>);
                        break;
                    case "image":
                        val = row[idx - mngCount];
                        mngCount += (!!mng ? 1 : 0);
                        col = (val == '' ? '' :
                            (<div key={key} className="col" style={{ width: width }}><img className={iClass} src={val}></img></div>));
                        
                        break;
                    case "span":
                        val = row[idx - mngCount];
                        mngCount += (!!mng ? 1 : 0);
                        let spanClick = function () { };
                        if (el.generic.click != null)
                        {
                            spanClick = function (ev)
                            {
                                let target = ev.target;
                                el.generic.click(ev, val);
                            }
                        }
                        col = (<div key={key} className="col" style={{ width: width }}>
                            <span data-val={val.dataVal ? val.dataVal : ''} onClick={spanClick} className={val.class}></span></div>);
                        
                        break;
                    default:
                        col = (<div key={key} className="col" style={{ width: width }}>{"unrecognized " + el.caption.type}</div>);
                        break;
                };
                return col;
            });
            let rows = [<div key={"row-" + rownum} className="row itemslist-data-row">{cols}</div>];
            rows.push(<div key={"rowspa-" + rownum} style={{ borderTop: "2px solid #d3d3d3", marginTop: "1rem", marginBottom: "1.5rem" }} />);
            return rows;
        }, this);
        const pgszopts = [{ value: 5, text: "5" }, { value: 10, text: "10" }, { value: 20, text: "20" }, { value: 30, text: "30" }, { value: 50, text: "50" }];

        if (!!this.props.navigation) {

            let selectSize = "";
            let navigatePage = "";
            if (this.props.navigation.totalItems.value > 0)
            {
                selectSize = (<div className="row"><USelectFlat name="pagesize" grow={false} width="7rem" colClass="no-padding-right" source={"list-" + this.props.listId}
                    options={pgszopts} selection={this.state.pageSize} onChange={this.sizeChange} />
                    <ULabelFlat colClass="no-padding-left" value={this.props.navigation.pageSize.text} /></div>);

                navigatePage = (<div className="row"><ULinkFlat grow={false} width="4rem" colClass="no-padding-right" onClick={this.navigationChange} name="first" source="pageNo" text="|<<" />
                    <ULinkFlat grow={false} width="2rem" colClass="no-padding" onClick={this.navigationChange} name="previous" source="pageNo" text="<" />
                    <UInputFlat itemClass={"nav-page-counter-first"} grow={false} width="3rem" colClass="no-padding" name="pageNo" source="pageNo" type="text"
                        onChange={this.pageChange} onKeyUp={this.keyUp} onBlur={this.lostFocus} value={this.state.inputPage} />
                    <ULabelFlat grow={false} width="3rem" colClass="no-padding nav-page-counter-second" value={"\xa0/ " + this.state.totPages.toString()} />
                    <ULinkFlat grow={false} width="2rem" colClass="no-padding" onClick={this.navigationChange} name="next" source="pageNo" text=">" />
                    <ULinkFlat grow={false} width="4rem" colClass="no-padding-left" onClick={this.navigationChange} name="last" source="pageNo" text=">>|" /></div>);

            }


        //if (!!this.props.navigation && this.props.navigation.totalItems.value > 0) {
            navigation = (
                <Fragment>
                    <div className="row itemslist-navigation">
                        <div className="col page-size">
                            {selectSize}
                            
                        </div>
                        <div className="col page-refresh">
                            <div className="row">
                                <UButtonFlat colClass="refresh-button" itemClass={(typeof this.props.navigation.refresh === "function") ? "" : "disabled"}
                                    width="4rem" grow={false} name="refresh" type="image" text="" onClick={this.refresh} />
                            </div>
                        </div>
                        <div className="col page-number">
                            {navigatePage}
                        </div>
                    </div>
                </Fragment>
            );
        }

        return (
            <div id={this.props.listId} className="items-list">
                <div className="row itemslist-header-row">{captions}</div>
                {entries}
                {navigation}
            </div>
        );
    }
}

//#endregion UItemsList



export class UserMessage extends React.Component {
    constructor(props) {
        super(props);

        this.typeMessage = props.typeMessage;
        this.section = props.section;
        this.userContext = props.userContext;

        this.dismiss = this.dismiss.bind(this);
        this.show = this.show.bind(this);
        this.hide = this.hide.bind(this);
        this.showMessage = this.showMessage.bind(this);
        this.state = {
            message: props.message ? props.message : "",
            currentSection: props.section
        };
    }
    showMessage(message) {
        this.setState({ message: message });
    }
    show(section) {

        try {
            let sectionToShow = section && section != null ? section : this.state.currentSection;
            loadUserMessage(this.userContext.jwtToken, sectionToShow,
                message => {

                    this.setState({ message: message, currentSection: sectionToShow });

                },
                ko => { });


        }
        catch (e) {

        }
    }
    hide() {

        this.setState({ message: "", currentSection: "" });
    }
    dismiss() {
        let section = this.state.currentSection;
        this.setState({ message: "" });
        if (this.props.onDismiss)
            this.props.onDismiss();
        try {
            if (section == null || section == "")
                return;
            deleteUserMessage(this.userContext.jwtToken, section,
                ok => {
                },
                ko => { });
        }
        catch (e) {

        }

    }
    componentDidUpdate(nextProps) {
        if (nextProps.message && nextProps.message != this.state.message)
            this.setState({ message: nextProps.message });
    }
    componentDidMount() {
        try {
            if (this.state.currentSection != null && this.state.currentSection != ""
                && (!this.props.message || this.props.message == ""))
                this.show(this.state.currentSection);
        }
        catch (e) {

        }
    }
   
    render() {
        let className = "alert alert-dismissible " + (this.typeMessage ? this.typeMessage : 'alert-danger');
        let visibility = { display: this.state.message ? "block" : "none" };

        return (
            <div className={className} style={visibility}>
                <div className="alert-title">{this.props.title}</div>
                <div className="alert-message">{this.state.message}</div>
                <div onClick={this.dismiss} className="alert-close"></div>
            </div>
        );
    }
}

export class TaskExecutingUserMessage extends React.Component {
    constructor(props) {
        super(props);

        this.loadMessage = this.loadMessage.bind(this);
        this.showMessage = this.showMessage.bind(this);
        this.onDismiss = this.onDismiss.bind(this);
        this.running = false;
        this.uc = props.userContext;
        this.section = "ORDER-CREATION-UPLOAD";

        this.state = {
            message: ""

        };
    }
    showMessage(message) {

        if (message != undefined && message != null)
            this.setState({ message: message });
        else
            this.setState({ message: this.props.message });

    }
    loadMessage(firstStart) {
        var me = this;
        if (firstStart && firstStart === true)
            this.running = true;
        try {
            loadUserMessage(this.uc.jwtToken, this.section,
                theMessage => {

                    if (theMessage != null && theMessage == "RUNNING") {
                        me.showMessage(me.props.message);

                        me.running = true;
                        setTimeout(function () {
                            me.loadMessage();
                        }, me.props.userMessageTimeout);
                    }
                    else {
                        if (me.running && me.props.onCompleted) {
                            me.showMessage("");
                            me.showMessage("Elaborazione completata");


                            if (me.props.onCompleted)
                                me.props.onCompleted.call(this);
                        }
                        else
                            //me.setState({ message: "" });
                            me.showMessage("");
                        me.running = false;

                    }
                },
                ko => {
                    setTimeout(function () {
                        me.showMessage(me.props.message);
                    }, me.props.userMessageTimeout);

                });
        }
        catch (e) {
            setTimeout(function () {
                me.showMessage(this.props.message);
            }, me.props.userMessageTimeout);
        }
    }

    componentDidMount() {
        try {

            this.loadMessage();
        }
        catch (e) {

        }
    }
    onDismiss() {
        this.setState({ message: "" });
    }
    render() {

        const message = this.state.message != ""
            ? (<UserMessage onDismiss={this.onDismiss} section={this.section} userContext={this.uc} message={this.state.message} typeMessage="alert-success" />) : "";


        return message;
    }
}


//#region Modals

/* message
*/
export class GearsLoaderBox extends React.Component {
    render() {
        return (
            <div className="fullscreen loader-box">
                <div className="cover" />
                <div className="msg-box container shadow-lg rounded-lg">
                    <div className="row loader-image"><div className="col"><div className="loader-image" /></div></div>
                    <div className="row loader-message"><div className="col"><h1>{this.props.message}</h1></div></div>
                </div>
            </div>
        );
    }
}
export class LoaderBox extends React.Component {
    render() {
        return (
            <div className="fullscreen loader-box">
                <div className="cover" />
                <div className="preloader loading">
                    <span className="slice" key="s0"></span>
                    <span className="slice" key="s1"></span>
                    <span className="slice" key="s2"></span>
                    <span className="slice" key="s3"></span>
                    <span className="slice" key="s4"></span>
                    <span className="slice" key="s5"></span>
                </div>
            </div>
        );
    }
}

/* data{captions,messages,buttons}
*/
export class MessageBox extends React.Component {

    render() {
        const captions = this.props.data.captions.map((el, idx) => (<div key={idx}>{el}</div>));
        const messages = this.props.data.messages.map((el, idx) => (el.length ? (<p key={idx}>{el}</p>) : (<div key={idx} className="space" />)));
        const buttons = this.props.data.buttons.map((el, idx) => (
            <div key={idx} className="col"><UButton type={el.type} extraClass="thin" text={el.text} onClick={el.click} /></div>
        ));

        return <UIMessageBox type={this.props.type} title={captions} message={messages}>
            {buttons}
        </UIMessageBox>;
    }

    xxxrender() {
        const center = !this.props.data.messages.length;
        const captions = this.props.data.captions.map((el, idx) => (<h5 key={idx} className={center ? "center" : null}>{el}</h5>));
        const messages = this.props.data.messages.map((el, idx) => (el.length ? (<p key={idx}>{el}</p>) : (<div key={idx} className="space" />)));
        const link = this.props.data.link ? (<div className="row"><div className="col message"><p><a target="_blank" href={this.props.data.link}>{this.props.data.linkText}</a></p></div></div>) : "";
        const buttons = this.props.data.buttons.map((el, idx) => (
            <div key={idx} className="col"><UButton type={el.type} extraClass="thin" text={el.text} onClick={el.click} /></div>
        ));

        return (
            <div className="fullscreen">
                <div className="cover"></div>
                <div className="msg-box container shadow-lg rounded" style={(this.props.width ? { width: this.props.width, flex: "0 0 " + this.props.width } : null)}>
                    <div className="row"><div className="col caption">{captions}</div></div>
                    <div className="row"><div className="col message">{messages}</div></div>
                    {link}
                    <div className="row">{buttons}</div>
                </div>
            </div>
        );
    }
}


/* title, width, icon, messages[<string>], buttons[{name, type, text, click}]
 * icon can be error, info, question, warning
*/
export class MessageBoxFluid extends React.Component {
    render() {
        const buttons = this.props.buttons.map((el, idx) => (
            <UIButton key={el.name + "-" + idx} name={el.text} className={el.type} text={el.text} onClick={el.click} />
        ));

        return <UIMessageBox type={this.props.type} title={this.props.title} message={this.props.messages}>
            {buttons}
        </UIMessageBox>;
    }
}

export class ErrorMessageBox extends React.Component {
    constructor(props) {
        super(props);
        //this.buttons = [{ name: "ok", type: "confirm", text: "OK", class: "right", click:props.closeModal}];
        this.buttons = [{ name: "ok", type: "confirm", text: "OK", click: props.closeModal }];
    }
    render() {

        return (<MessageBoxFluid title="Errore" type={"error"} messages={Array.isArray(this.props.messages) ? this.props.messages : [this.props.messages]} buttons={this.buttons} />);

    }

}
/* title, buttons, children, onClose, width
*/
export class ModalBox extends React.Component {
    constructor(props) {
        super(props);
        this.closeClick = this.closeClick.bind(this);
    }

    closeClick(ev) {
        this.props.onClose(ev, "x-close");
    }

    //<div className="col-1 close-modal"><h5 onClick={this.closeClick}>&times;</h5></div>
    render() {
        const buttons = this.props.buttons.map((el, idx) => (
            <div key={"btn-" + idx} className="col"><UButton extraClass={"thin " + (el.class ? el.class : "")} type={el.type} text={el.text} onClick={el.click} /></div>
        ));
        const titleSubSpace = this.props.className === 'titleThin' ? { marginTop: "0rem", borderTop: "1px solid #a7a7a7", marginBottom: "1rem" }
            : { marginTop: "2rem", borderTop: "1px solid #a7a7a7", marginBottom: "3rem" };
        return (
            <div className="fullscreen">
                <div className="cover"></div>
                <div className="modal-box msg-box container shadow-lg rounded" style={(this.props.width ? { width: this.props.width, flex: "0 0 " + this.props.width } : null)}>
                    <div className="row">
                        <div className="col caption"><h5>{this.props.title}</h5></div>
                        <div className="col-2 close-modal"><div className="times" onClick={this.closeClick} /></div>
                    </div>
                    <div className="row"><div className="col body">{this.props.children}</div></div>
                    <div className="row">{buttons}</div>
                </div>
            </div>
        );
    }
}


/* title, width, buttons, children
*/
export class ModalBoxFluid extends React.Component {
    constructor(props) {
        super(props);
        this.closeClick = this.closeClick.bind(this);
    }

    closeClick(ev) {
        if (typeof this.props.onClose === "function") this.props.onClose(ev, "x-close");
    }

    render() {
        const buttons = this.props.buttons.map((el, idx) => (
            <UButton key={idx} type={el.type} text={el.text} onClick={el.click} />
        ));
        return (
            <div className="fullscreen">
                <div className="cover"></div>
                <div className="msg-box container-fluid shadow-lg rounded" style={(this.props.width ? { width: this.props.width, flex: "0 0 " + this.props.width } : null)}>
                    <div className="row titles">
                        <div className="col"><h5>{this.props.title}</h5></div>
                        <div className="col-2 close-modal"><div className={(typeof this.props.onClose === "function") ? "times right" : ""} onClick={this.closeClick} /></div>
                    </div>
                    <div className="row elements"><div className="col">{this.props.children}</div></div>
                    <UButtonGroup rowClass="no-padding">{buttons}</UButtonGroup>
                </div>
            </div>
        );
    }
}




export class OrderCostMessage extends React.Component {
    constructor(props) {
        super(props);
        this.acceptCost = this.acceptCost.bind(this);
        this.dismissCost = this.dismissCost.bind(this);
        this.buyCost = this.buyCost.bind(this);

        this.buildMessages = this.buildMessages.bind(this);
        this.buildButtons = this.buildButtons.bind(this);

        this.carrierCostModalConf = this.buildConfiguration();
    }
    buildConfiguration() {

        if (!this.props.carrierCostModal)
            return {
                captions: ["Costo ordine corriere"],
                messages: ["Disponibili {0} Costo Ordine {1}", "Vuoi continuare con la creazione dell'ordine?", " Il presente importo non è comprensivo dei costi relativi ad eventuali Servizi Accessori", "che potranno esservi addebitati in un momento successivo alla conclusione dell’ordine.", "Per la definizione di Servizi Accessori e dei relativi costi,","si rimanda alle Condizioni Generali di Vendita di Sendabox pubblicate sul nostro sito"],
                okText: "Accetto",
                cancelText: "Annulla",
                buyText: "Acquista"

            };
        else
            return this.props.carrierCostModal;

    }
    acceptCost() {
        if (this.props.onAction)
            this.props.onAction("accept");
    }
    dismissCost() {
        if (this.props.onAction)
            this.props.onAction("dismiss");
    }
    buyCost() {
        if (this.props.onAction)
            this.props.onAction("buy");
    }
    buildButtons() {
        let buttons = [];

        if (this.props.carrierCostCalcDto) {

            if (!this.props.carrierCostCalcDto.hasError && !this.props.carrierCostCalcDto.notEnoughCredits) {
                buttons.push({
                    name: "ok", type: "confirm cost-modal-confirm", width: "",
                    text: this.carrierCostModalConf.okText, class: "right", click: this.acceptCost
                });


            }
            else if (this.props.carrierCostCalcDto.notEnoughCredits) {
                buttons.push({
                    name: "acquista", type: "confirm cost-modal-confirm", width: "",
                    text: this.carrierCostModalConf.buyText, class: "right", click: this.buyCost
                });
            }
        }

        buttons.push({
            name: "cancel", type: "cancel confirm cost-modal-cancel", width: "",
            text: this.carrierCostModalConf.cancelText, class: "right", click: this.dismissCost
        });
        return buttons;
    }
    buildMessages() {
        let messages = [];
        let dwnOrders = [];
        let style = "text-center my-auto";
        if (this.props.carrierCostCalcDto) {

            if (!this.props.carrierCostCalcDto.hasError && !this.props.carrierCostCalcDto.notEnoughCredits) {

                messages = this.carrierCostModalConf.messages.map((a) => {

                    return a.replace("{0}", this.props.carrierCostCalcDto.total ? this.props.carrierCostCalcDto.total : "n/d").
                        replace("{1}", this.props.carrierCostCalcDto.cost ? this.props.carrierCostCalcDto.cost : "n/d");

                });
            }
            else if (this.props.carrierCostCalcDto.hasError) {

                let errorMessages = this.props.carrierCostCalcDto.errorMessage.split(",");
                errorMessages.forEach((item) => {
                    style = "text-left my-auto";
                    let toks = item.split(":");
                    if (toks.length > 1)
                        messages.push(<div><span><b>{toks[0]}:</b></span><span> {toks[1]}</span></div>);
                    else
                        messages.push(<span>{item}</span>);
                });

            }
            else if (this.props.carrierCostCalcDto.notEnoughCredits) {
                messages.push(this.carrierCostModalConf.messages[0].replace("{0}", this.props.carrierCostCalcDto.total ? this.props.carrierCostCalcDto.total : "n/d").
                    replace("{1}", this.props.carrierCostCalcDto.cost ? this.props.carrierCostCalcDto.cost : "n/d"));

                messages.push("Credito non sufficiente per l'ordine");
            }
        }
        return { messages: messages, style: style };
    }

    render() {
        let messages = [];
        let dwnOrders = [];
        let buttons = [];

        if (this.props.carrierCostCalcDto) {

            if (this.props.carrierCostCalcDto.notEnoughCredits) {

                messages.push(this.carrierCostModalConf.messages[0].replace("{0}", this.props.carrierCostCalcDto.total ? this.props.carrierCostCalcDto.total : "n/d").
                    replace("{1}", this.props.carrierCostCalcDto.cost ? this.props.carrierCostCalcDto.cost : "n/d"));
                messages.push("Credito non sufficiente per l'ordine");

                buttons.push(<UIButton key="btn-buy" className="confirm" text={this.carrierCostModalConf.buyText} onClick={this.buyCost} />);
                
            }
            else if (this.props.carrierCostCalcDto.cost > 0) {

                this.carrierCostModalConf.messages.map((a) => {
                    messages.push(a.replace("{0}", this.props.carrierCostCalcDto.total ? this.props.carrierCostCalcDto.total : "n/d").
                        replace("{1}", this.props.carrierCostCalcDto.cost ? this.props.carrierCostCalcDto.cost : "n/d"));
                });

                buttons.push(<UIButton key="btn-ok" className="confirm" text={this.carrierCostModalConf.okText} onClick={this.acceptCost} />);
            }

            if (this.props.carrierCostCalcDto.hasError && this.props.carrierCostCalcDto.errorMessage) {
                if (messages.length > 0) {
                    messages.push(" ");
                    messages.push("Errore su " + Object.keys(this.props.carrierCostCalcDto.errorMessage).length + " ordini:");
                    messages.push(" ");
                }
                let csv = {};
                Object.keys(this.props.carrierCostCalcDto.errorMessage).forEach((key, index) => {
                    messages.push("Ordine " + key + ": " + this.props.carrierCostCalcDto.errorMessage[key]);
                    if (this.props.carrierCostCalcDto.errorMessage[key].endsWith(" [*]"))
                        csv[key] = this.props.carrierCostCalcDto.errorMessage[key];
                });

                if(Object.keys(csv).length > 0)
                    buttons.push(<UIButton key="btn-dnw" className="" text={Languages.getSection("OrderCreation").message.orderFailsCsvBtn} onClick={(e) => { downloadOrdersCsv(this.props.userContext.jwtToken, csv, () => { }) }} />);
            }

            buttons.push(<UIButton key="btn-cancel" className="" text={this.carrierCostModalConf.cancelText} onClick={this.dismissCost} />);
        }

        return <UIMessageBox
            type="info"
            title={this.carrierCostModalConf.captions[0]}
            message={messages}>
            {buttons}
        </UIMessageBox>
    }

}